<div class="udex-pe-24 udex-pe-sm-0 udex-py-20 udex-py-sm-0">
  <div class="cps-price-details d-flex align-items-center">
    <udex-button
      class="cps-price-details__button"
      size="Medium"
      icon="sap-icon://message-information"
      design="Tertiary"
      (keydown.enter)="openModal()"
      (click)="openModal()"
      accessible-name="priceDetailsTooltip"
      accessible-role="Button"
    >
    </udex-button>
    <span class="cps-price-details__heading heading__regular--xxxs udex-ms-2">
      {{ dcpOrderEntryService.getSubtotalByCode(entry, this.entry.product.code) }}
    </span>

    <ng-template #modalContentTemplate class="cps-price-details-modal">
      <div
        class="cps-price-details-modal__content">
        <h5 class="cps-price-details-modal__heading udex-mb-12 udex-mb-lg-12 heading__medium--xxxxs">
          {{ 'cartItems.priceTooltip.per.header' | cxTranslate }}</h5>
        <table class="cps-price-details-modal__table w-100 body--xs">
          <tr class="cps-price-details-modal__table-row d-none d-sm-flex flex-sm-row justify-content-between">
            <th class="udex-px-0 udex-py-sm-8">
              <span class="cps-price-details-modal__table-header">
                {{ 'cartItems.priceTooltip.per.licenseMaterial' | cxTranslate }}
              </span>
            </th>
            <th *ngIf="showConfigurationDescription"
                class="cps-price-details-modal__table-header udex-px-0 udex-py-sm-8">
              <span class="cps-price-details-modal__table-header">
                {{ 'cartItems.priceTooltip.breakdown.configuration' | cxTranslate }}
              </span>
            </th>
            <th class="cps-price-details-modal__table-header udex-px-0 udex-py-sm-8">
              <span class="cps-price-details-modal__table-header">
                {{ 'cartItems.priceTooltip.breakdown.cost' | cxTranslate }}
              </span>
            </th>
          </tr>
          <tr
            class="cps-price-details-modal__table-row d-flex flex-column flex-sm-row justify-content-between udex-py-sm-8"
            *ngFor="let priceTooltipItem of priceTooltipItems">
            <td class="d-flex flex-column udex-px-0 ">
              <span
                class="cps-price-details-modal__table-header d-sm-none udex-pb-4 udex-pb-sm-0">{{ 'cartItems.priceTooltip.per.licenseMaterial' | cxTranslate }}</span>
              <span
                class="cps-price-details-modal__table-text udex-pb-4 udex-pb-sm-0">{{ priceTooltipItem.materialName }}</span>
            </td>
            <td *ngIf="showConfigurationDescription" class="d-flex flex-column udex-px-0 ">
              <span
                class="cps-price-details-modal__table-header d-sm-none udex-pb-4 udex-pb-sm-0">{{ 'cartItems.priceTooltip.breakdown.configuration' | cxTranslate }}</span>
              <span
                class="cps-price-details-modal__table-text udex-pb-4 udex-pb-sm-0"></span>{{ priceTooltipItem.netPriceDescription }}
            </td>
            <td class="d-flex flex-column udex-px-0 ">
              <span
                class="cps-price-details-modal__table-header d-sm-none udex-pb-4 udex-pb-sm-0">{{ 'cartItems.priceTooltip.breakdown.cost' | cxTranslate }}</span>
              <span class="cps-price-details-modal__table-text">{{ priceTooltipItem.totalValue }}</span>
            </td>
          </tr>
        </table>
        <div
          class="cps-price-details-modal__subtotal udex-mt-20 udex-mt-sm-16 udex-mt-lg-20 d-flex justify-content-between">
          <h5 class="cps-price-details-modal__subtotal-heading heading__regular--xxxs">
            {{ 'configurator.subtotal' | cxTranslate }}</h5>
          <div class="cps-price-details-modal__subtotal-values d-flex flex-column">
            <h5 class="cps-price-details-modal__subtotal-value heading__medium--xxxs text-end">
              {{ dcpOrderEntryService.getSubtotalByCode(entry, this.entry.product.code) }}</h5>
            <span class="cps-price-details-modal__subtotal-tax ms-auto udex-mt-4 udex-mt-sm-12 udex-mt-lg-16 body--xs">
              {{ 'cartItems.priceTooltip.subtotal.taxCalculated' | cxTranslate }}
            </span>
          </div>
        </div>
        <div *ngIf="dcpOrderEntryService.getDiscountFromSubtotal(entry, this.entry.product.code)"
             class="cps-price-details-modal__discount udex-mt-4 d-flex justify-content-end">
          <p class="body--xs udex-m-0">
            {{ 'cartItems.discounts.discount' | cxTranslate : {formattedAbsoluteValue: dcpOrderEntryService.getDiscountFromSubtotal(entry, this.entry.product.code)} }}
          </p>
        </div>
        <ng-container *ngIf="showTooltipPriceCalculationBreakdown$ | async">
          <div *ngIf="(subtotals?.length > 0) && commercialModelShowTooltipBreakdown"
               class="cps-price-details-modal__calculation udex-mt-24 udex-mt-sm-16">
            <div class="cps-price-details-modal__calculation-heading text-start udex-mb-sm-12 heading__medium--xxxxs">
              {{ 'configurator.yearByYearPricingBreakdown' | cxTranslate }}
            </div>
            <div *ngIf="subtotals.length > 0">
              <div class="cps-price-details-modal__calculation-item cx-configuration-info"
                   *ngFor="let subtotalPricingItem of subtotals">
                <div
                  class="cps-price-details-modal__calculation-row udex-pt-16 udex-py-sm-8 body--xs d-flex flex-row align-items-center justify-content-between">
                  <span class="cps-price-details-modal__calculation-date d-flex flex-column  d-sm-grid">
                    <span class="date-item">{{ subtotalPricingItem?.startDate | dcpDate }}</span>
                    <span class="date-item text-sm-center">&ndash;</span>
                    <span class="date-item">{{ subtotalPricingItem?.endDate | dcpDate }}</span>
                  </span>
                  <span
                    class="cps-price-details-modal__calculation-value">{{ subtotalPricingItem?.formattedValues?.totalValue }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </ng-template>
  </div>

  <span *ngIf="dcpOrderEntryService.getDiscountFromSubtotal(entry, this.entry.product.code)"
        class="d-flex justify-content-end cps-price-details__discount body--xs">
    {{ 'cartItems.discounts.discount' | cxTranslate : {formattedAbsoluteValue: dcpOrderEntryService.getDiscountFromSubtotal(entry, this.entry.product.code)} }}
  </span>
</div>
